import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_PREV_PAGE_FILTERS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MARKETING_TOTALS_SUCCESS,
  FETCH_MARKETING_REFERRAL_SUCCESS,
  FETCH_MARKETING_PROFILE_RETENTION_SUCCESS,
  FETCH_MARKETING_INTROS_RETAINED_SUCCESS
} from "./marketingSagas";

export const initialState = {
  currentUser: {},
  initRequest: false,
  prevPageFilters: { prevDate: null },
  currencySymbol: "",
  totals: {},
  referralBySource: [],
  profileRetention: {},
  introsRetained: {},
  isLoading: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload || state.isLoading
    }),
    [SET_PREV_PAGE_FILTERS]: (state, action) => ({
      ...state,
      prevPageFilters: { ...action.payload }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initRequest: true
    }),
    [FETCH_MARKETING_TOTALS_SUCCESS]: (state, action) => ({
      ...state,
      totals: action.payload.totals || state.totals
    }),
    [FETCH_MARKETING_REFERRAL_SUCCESS]: (state, action) => ({
      ...state,
      referralBySource: action.payload.referralBySource || state.referralBySource,
      currencySymbol: action.payload.currencySymbol || state.currencySymbol
    }),
    [FETCH_MARKETING_PROFILE_RETENTION_SUCCESS]: (state, action) => ({
      ...state,
      profileRetention: action.payload.profileRetention || state.profileRetention
    }),
    [FETCH_MARKETING_INTROS_RETAINED_SUCCESS]: (state, action) => ({
      ...state,
      introsRetained: action.payload.totals || state.profileRetention,
      isLoading: false
    })
  },
  initialState
);
